<div class="progress-buttons">
  @if (previousProgress) {
    <button class="secondary"
            [disabled]="!progressChangeable"
            (click)="goToPreviousProgress()">
      <div class="spinner-wrapper"
           *ngIf="!progressChangeable">
        <div #spinner class="spinner">
          <mat-spinner color="accent"></mat-spinner>
        </div>
      </div>
      {{ 'i18n.button.back' | translate }}
    </button>
  }
  @if (nextProgress) {
    <button class="primary"
            [disabled]="!progressChangeable"
            validate-design-step
            (validationDone)="setCurrentProgress(nextProgress.id)"
            (validationFailed)="onValidationFailed($event)">
      <div class="spinner-wrapper"
           *ngIf="!progressChangeable">
        <div #spinner class="spinner">
          <mat-spinner color="accent"></mat-spinner>
        </div>
      </div>
      {{ 'i18n.button.continue' | translate }}
    </button>
  }
  @if (!nextProgress) {
    <button class="primary"
            [disabled]="!progressChangeable"
            validate-design-step
            finalize-design
            (finalizedDesign)="finalizationDone($event)"
            (validationFailed)="onValidationFailed($event)">
      <div class="spinner-wrapper"
           *ngIf="!progressChangeable">
        <div #spinner class="spinner">
          <mat-spinner color="accent"></mat-spinner>
        </div>
      </div>
      {{ 'i18n.button.addToCart' | translate }}
    </button>
  }
</div>
